import React from 'react';
import { Box, Heading, Text, VStack, HStack, Link, Icon, Image, Flex, SimpleGrid } from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';
import { RiArrowRightUpLine } from 'react-icons/ri';
import { motion } from 'framer-motion';
import GridLayout from '../components/GridLayout';
import BackgroundEffects from '../components/BackgroundEffects';
import LagosTime from '../components/LagosTime';

// Import the ProjectCard component
import ProjectCard from '../components/ProjectCard';

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

const Home = () => {
    // Project data array
    const projects = [
        {
            id: 1,
            title: "Quantum Chain",
            description: "Quantum-resistant blockchain for the post-quantum era with lightning-fast transactions and zero-knowledge privacy",
            imageUrl: "/quantum-chain.png", // Save the screenshot as quantum-chain.png in your public folder
            imageAlt: "Quantum Chain Project",
            link: "https://quantom-tau.vercel.app"
        },
        {
            id: 2,
            title: "Astrowtig",
            description: "A social Ai music streaming platform that rewards it users with token",
            imageUrl: "/astrotwig.png",
            imageAlt: "Astrotwig",
            link: "https://astrotwig.com"
        },
        {
            id: 3,
            title: "Hafrik",
            description: "Hafrik is the ultimate social networking platform for foreigners in china.",
            imageUrl: "/hafrik.png",
            imageAlt: "hafrik",
            link: "https://hafrik.com/welcome"
        },
        {
            id: 4,
            title: "Slydo",
            description: "a social technology that helps people connect and grow businesses.",
            imageUrl: "/slydo.png",
            imageAlt: "slydo",
            link: "https://slydo.co/"
        },
        {
            id: 5,
            title: "hafrikplay",
            description: "a Pan-African-inspired music streaming platform. ",
            imageUrl: "/hafrikplay.png",
            imageAlt: "hafrikplay",
            link: "https://hafrikplay.com/"
        },


    ];

    return (
        <>
            <BackgroundEffects />
            <GridLayout>
                {/* Hero Section */}
                <Box id="home" gridColumn={{ base: "1 / 13", md: "1 / 8" }} gridRow={{ base: "1", md: "1 / 3" }} p={{ base: "20px", md: "40px" }}>
                    <MotionHeading
                        as="h1"
                        fontSize={{ base: "4xl", sm: "5xl", md: "6xl", lg: "9xl" }}
                        fontWeight="bold"
                        lineHeight="0.9"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        I'm Smith
                    </MotionHeading>
                    <MotionText
                        fontSize={{ base: "lg", md: "xl" }}
                        mt={4}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        A creative <Text as="span" color="cyan.400">fullstack</Text> developer specializing in web3, mobile & web applications
                    </MotionText>
                </Box>

                {/* Profile Image */}
                <Box
                    gridColumn={{ base: "1 / 13", md: "8 / 13" }}
                    gridRow={{ base: "2", md: "1 / 3" }}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    p={{ base: "20px", md: "40px" }}
                >
                    <MotionBox
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                    >
                        <Image
                            src="/avatar.png"
                            alt="Smith"
                            borderRadius="md"
                            maxW={{ base: "200px", md: "300px" }}
                            w="100%"
                        />
                    </MotionBox>
                </Box>

                {/* Location Info and Images Section - Improved layout */}
                <Box
                    gridColumn="1 / 13"
                    gridRow="3"
                    p="20px"
                    display="flex"
                    flexDirection={{ base: "column", md: "row" }}
                    alignItems="center"
                    justifyContent="space-between"
                    gap={4}
                >
                    {/* Lagos Time */}
                    <Flex
                        direction="column"
                        align={{ base: "center", md: "flex-start" }}
                        p={4}
                        borderRadius="md"
                        bg="rgba(0,0,0,0.3)"
                        backdropFilter="blur(10px)"
                        border="1px solid rgba(255,255,255,0.1)"
                        flex={{ base: "1", md: "1" }}
                        w={{ base: "100%", md: "auto" }}
                    >
                        <LagosTime />

                    </Flex>

                    {/* NFT Image */}
                    <Box
                        p={4}
                        borderRadius="md"
                        bg="rgba(0,0,0,0.3)"
                        backdropFilter="blur(10px)"
                        border="1px solid rgba(255,255,255,0.1)"
                        flex={{ base: "1", md: "1" }}
                        w={{ base: "100%", md: "auto" }}
                        display={{ base: "none", md: "block" }}  // Hide on mobile
                    >
                        <Image
                            src="https://cassette.sphdigital.com.sg/image/thepeak/864211938788f543b65acc5de1c6dd8ca89953a2a1ebecb0da57e43e13a6de4e?w=1000&q=85"
                            alt="NFT - DeGods Collection"
                            borderRadius="md"
                            maxW="100%"
                            h={{ base: "150px", md: "auto" }}
                            objectFit="cover"
                        />
                    </Box>

                    {/* Decorative Image */}
                    <Box
                        p={4}
                        borderRadius="md"
                        bg="rgba(0,0,0,0.3)"
                        backdropFilter="blur(10px)"
                        border="1px solid rgba(255,255,255,0.1)"
                        flex={{ base: "1", md: "1" }}
                        w={{ base: "100%", md: "auto" }}
                        display={{ base: "none", md: "block" }}  // Hide on mobile
                    >
                        <Image
                            src="https://creativereview.imgix.net/content/uploads/2021/10/imaeg.jpg?auto=compress,format&q=60&w=1200&h=675"
                            alt="Decorative"
                            borderRadius="md"
                            maxW="100%"
                            h={{ base: "150px", md: "auto" }}
                            objectFit="cover"
                        />
                    </Box>
                </Box>

                {/* Projects Heading */}
                <Box id="projects" gridColumn="1 / 13" gridRow="4" p={{ base: "20px", md: "40px" }}>
                    <MotionHeading
                        as="h2"
                        fontSize={{ base: "2xl", md: "4xl" }}
                        fontWeight="bold"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        Building <Text as="span" color="cyan.400">Innovative</Text> Solutions For:
                    </MotionHeading>
                    <MotionText
                        fontSize={{ base: "md", md: "lg" }}
                        maxW="800px"
                        mt={4}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        Mobile Applications, SaaS Platforms, Web3 Solutions, Memecoins, DeFi Protocols,
                        Smart Contract Development, and Custom Enterprise Solutions,....and more.
                    </MotionText>
                </Box>

                {/* Proof of Work Heading */}
                <Box gridColumn="1 / 13" gridRow="5" p={{ base: "20px", md: "40px" }} pt="0">
                    <MotionHeading
                        as="h2"
                        fontSize={{ base: "2xl", md: "4xl" }}
                        fontWeight="bold"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        Proof of Work:
                    </MotionHeading>
                </Box>

                {/* Projects List - Horizontal on desktop, vertical on mobile */}
                <Box gridColumn="1 / 13" gridRow="6" p={{ base: "20px", md: "40px" }}>
                    {projects.map((project, index) => (
                        <Flex
                            key={project.id}
                            direction={{ base: "column", md: "row" }}
                            mb={10}
                            alignItems="center"
                            justifyContent="space-between"
                            borderRadius="md"
                            bg="rgba(0,0,0,0.2)"
                            backdropFilter="blur(5px)"
                            border="1px solid rgba(255,255,255,0.05)"
                            overflow="hidden"
                            transition="all 0.3s ease"
                            _hover={{
                                transform: "translateY(-5px)",
                                boxShadow: "0 10px 30px -10px rgba(0, 210, 255, 0.2)"
                            }}
                        >
                            {/* Project Image with Gradient Background */}
                            <Box
                                flex={{ md: 1.2 }}
                                w={{ base: "100%", md: "auto" }}
                                position="relative"
                                overflow="hidden"
                                h={{ base: "200px", md: "700px" }}
                                bg={index % 2 === 0
                                    ? "#0F172A"
                                    : "#1A1B26"}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                p={8}
                            >
                                <Box
                                    position="absolute"
                                    top="0"
                                    left="0"
                                    right="0"
                                    bottom="0"
                                    bgGradient={index % 2 === 0
                                        ? "linear(to-br, #0EA5E9, #7E22CE)"
                                        : "linear(to-br, #6366F1, #EC4899)"}
                                    opacity="0.2"
                                    mixBlendMode="hard-light"
                                />
                                <Image
                                    src={project.imageUrl}
                                    alt={project.imageAlt}
                                    maxW="90%"
                                    maxH="90%"
                                    objectFit="contain"
                                    position="relative"
                                    zIndex="1"
                                    boxShadow="dark-lg"
                                    borderRadius="xl"
                                    filter="contrast(1.2) brightness(1.1)"
                                    transform="scale(1.02)"
                                />
                            </Box>

                            {/* Project Info */}
                            <VStack
                                align="flex-start"
                                p={6}
                                spacing={4}
                                flex={{ md: 1 }}
                            >
                                <MotionHeading
                                    as="h3"
                                    fontSize={{ base: "2xl", md: "3xl" }}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5 }}
                                    viewport={{ once: true }}
                                >
                                    {project.title}
                                </MotionHeading>

                                <MotionText
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.1 }}
                                    viewport={{ once: true }}
                                >
                                    {project.description}
                                </MotionText>

                                <MotionBox
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <Link
                                        href={project.link}
                                        display="flex"
                                        alignItems="center"
                                        color="cyan.400"
                                        _hover={{ color: "purple.400" }}
                                        role="group"
                                        isExternal
                                    >
                                        View Live <Icon as={RiArrowRightUpLine} ml={2} fontSize="20px" transform="rotate(-45deg)" transition="transform 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)" }} />
                                    </Link>
                                </MotionBox>
                            </VStack>
                        </Flex>
                    ))}
                </Box>

                {/* Contact Section */}
                <Box id="contact" gridColumn="1 / 13" gridRow="7" p={{ base: "20px", md: "40px" }}>
                    <MotionHeading
                        as="h2"
                        fontSize={{ base: "2xl", md: "5xl" }}
                        fontWeight="bold"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        Let's Connect
                    </MotionHeading>
                </Box>

                {/* Contact Links */}
                <Box gridColumn="1 / 13" gridRow="8" p={{ base: "20px", md: "40px" }} pt="0">
                    <VStack align="flex-start" spacing={4} w="100%">
                        <MotionBox
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            viewport={{ once: true }}
                            w="100%"
                        >
                            <Link href="https://t.me/kiddo4lyf" display="flex" alignItems="center" py={3} borderBottom="1px solid rgba(255, 255, 255, 0.1)" w="100%" role="group">
                                <HStack w="100%" justify="space-between">
                                    <Text fontSize={{ base: "lg", md: "xl" }}>Telegram</Text>
                                    <Icon as={RiArrowRightUpLine} transform="rotate(-45deg)" transition="all 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)", color: "cyan.400" }} />
                                </HStack>
                            </Link>
                        </MotionBox>

                        <MotionBox
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                            w="100%"
                        >
                            <Link href="https://twitter.com/smithonchain" display="flex" alignItems="center" py={3} borderBottom="1px solid rgba(255, 255, 255, 0.1)" w="100%" role="group">
                                <HStack w="100%" justify="space-between">
                                    <Text fontSize={{ base: "lg", md: "xl" }}>Twitter</Text>
                                    <Icon as={RiArrowRightUpLine} transform="rotate(-45deg)" transition="all 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)", color: "cyan.400" }} />
                                </HStack>
                            </Link>
                        </MotionBox>

                        <MotionBox
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            viewport={{ once: true }}
                            w="100%"
                        >
                            <Link href="mailto:olanrewajutaiwo183@gmail.com" display="flex" alignItems="center" py={3} borderBottom="1px solid rgba(255, 255, 255, 0.1)" w="100%" role="group">
                                <HStack w="100%" justify="space-between">
                                    <Text fontSize={{ base: "lg", md: "xl" }}>Mail</Text>
                                    <Icon as={RiArrowRightUpLine} transform="rotate(-45deg)" transition="all 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)", color: "cyan.400" }} />
                                </HStack>
                            </Link>
                        </MotionBox>

                        <MotionBox
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            viewport={{ once: true }}
                            w="100%"
                        >
                            <Link href="https://discord.com/users/kiddo__1" display="flex" alignItems="center" py={3} borderBottom="1px solid rgba(255, 255, 255, 0.1)" w="100%" role="group">
                                <HStack w="100%" justify="space-between">
                                    <Text fontSize={{ base: "lg", md: "xl" }}>Discord</Text>
                                    <Icon as={RiArrowRightUpLine} transform="rotate(-45deg)" transition="all 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)", color: "cyan.400" }} />
                                </HStack>
                            </Link>
                        </MotionBox>
                    </VStack>
                </Box>

                {/* Remove About Section and adjust Footer row */}
                {/* Footer */}
                <Box gridColumn="1 / 13" gridRow="9" p={{ base: "20px", md: "40px" }} mt={10}>
                    <Flex justify="space-between" align="center" borderTop="1px solid rgba(255, 255, 255, 0.1)" pt={6}>
                        <Text fontSize="sm" color="gray.500">© 2025 Smith. All rights reserved.</Text>

                    </Flex>
                </Box>
            </GridLayout>
        </>
    );
};

export default Home;